(function(){
  'use strict';

  var responsiveImages = new WeakSet();
  var imageResizeObserver = 'ResizeObserver' in window ? new ResizeObserver(function(entries){
    entries.forEach(function(entry){
      if (entry.contentRect.width > 0) entry.target.sizes = Math.ceil(entry.contentRect.width) + 'px';
    });
  }) : null;

  function setCardImage(img, url){
    if (!url) return;
    if (img.hasAttribute('srcset')) {
      try {
        var source = new URL(url, document.baseURI);
        var srcset = [240, 360, 480, 640, 900, 1200].map(function(width){
          source.searchParams.set('width', String(width));
          return source.href + ' ' + width + 'w';
        }).join(', ');
        source.searchParams.set('width', '640');
        var slotWidth = Math.ceil(img.getBoundingClientRect().width);
        if (slotWidth > 0) img.sizes = slotWidth + 'px';
        if (imageResizeObserver && !responsiveImages.has(img)) {
          responsiveImages.add(img);
          imageResizeObserver.observe(img);
        }
        img.srcset = srcset;
        img.src = source.href;
      } catch (error) {
        img.removeAttribute('srcset');
        img.src = url;
      }
    } else {
      img.src = url;
    }
  }

  function bindCycleCard(card){
    if (card.__wdBound) return;
    card.__wdBound = true;
    var raw = (card.getAttribute('data-cycle-urls') || '').trim();
    if (!raw) return;
    var urls = raw.split(',').map(function(s){ return s.trim(); }).filter(Boolean);
    if (urls.length <= 1) return;

    var img = card.querySelector('.wd-card__img');
    if (!img) return;
    var dots = card.querySelectorAll('.wd-card__dot');
    var i = 0;

    function goto(next){
      i = ((next % urls.length) + urls.length) % urls.length;
      setCardImage(img, urls[i]);
      dots.forEach(function(d, di){ d.classList.toggle('is-on', di === i); });
    }


    var timer = null;
    var isFinePointer = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    if (isFinePointer){
      card.addEventListener('mouseenter', function(){
        clearInterval(timer);
        timer = setInterval(function(){ goto(i + 1); }, 900);
      });
      card.addEventListener('mouseleave', function(){
        clearInterval(timer);
        timer = null;
        goto(0);
      });
    } else {
      var dotsWrap = card.querySelector('.wd-card__dots');
      if (dotsWrap){
        dotsWrap.style.pointerEvents = 'auto';
        dotsWrap.addEventListener('click', function(e){
          e.preventDefault();
          e.stopPropagation();
          goto(i + 1);
        });
      }
    }
  }

  function bindSwatchCard(card){
    if (card.__wdSwatchBound) return;
    card.__wdSwatchBound = true;

    var img = card.querySelector('.wd-card__img');
    var swatches = Array.prototype.slice.call(card.querySelectorAll('[data-card-swatch]'));
    if (!img || swatches.length <= 1) return;
    var baseSrc = img.getAttribute('src');


    function activate(sw){
      var u = sw.getAttribute('data-swatch-img');
      if (u) setCardImage(img, u);
      swatches.forEach(function(s){ s.classList.toggle('is-active-swatch', s === sw); });
    }

    var isFinePointer = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    swatches.forEach(function(sw){
      if (isFinePointer){
        sw.addEventListener('mouseenter', function(){ activate(sw); });
      }
      sw.addEventListener('click', function(e){
        e.preventDefault();
        e.stopPropagation();
        activate(sw);
      });
    });

    if (isFinePointer){
      card.addEventListener('mouseleave', function(){
        if (baseSrc) setCardImage(img, baseSrc);
        swatches.forEach(function(s, i){ s.classList.toggle('is-active-swatch', i === 0); });
      });
    }
  }

  // The mount is visible by default and empty until the reviews widget populates
  // it. Once populated, hide it only if the review count is below the threshold.
  function checkRating(el){
    var compact = el.querySelector('.wbd-rating-compact');
    if (!compact) return false;
    var countEl = compact.querySelector('.wbd-rating-compact__count');
    var n = 0;
    if (countEl){
      var m = countEl.textContent.match(/\d+/);
      n = m ? parseInt(m[0], 10) : 0;
      countEl.textContent = '(' + n + ')';
    }
    var min = parseInt(el.getAttribute('data-min') || '0', 10) || 0;
    if (n < min){ el.classList.add('is-thin'); }
    return true;
  }

  function bindRating(el){
    if (el.__wdRatingBound) return;
    el.__wdRatingBound = true;
    if (checkRating(el)) return;
    var obs = new MutationObserver(function(){ if (checkRating(el)) obs.disconnect(); });
    obs.observe(el, { childList: true, subtree: true });
  }

  function bindAll(root){
    var scope = root || document;
    scope.querySelectorAll('.wd-card--cycle[data-cycle-urls]').forEach(bindCycleCard);
    scope.querySelectorAll('.wd-card--swatch').forEach(bindSwatchCard);
    scope.querySelectorAll('[data-card-rating]').forEach(bindRating);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){ bindAll(document); });
  } else {
    bindAll(document);
  }

  // Shopify's theme editor can replace a section after the global asset loaded.
  document.addEventListener('shopify:section:load', function(e){ bindAll(e.target); });
})();
